import Severity, { getOrder } from "./Severity";
import AnalysedCriterion from "./AnalysedCriterion";

export default interface SeveritySummary {
  type: Severity;
  className: string;
  total: number;
  label: string;
}

export function getSeveritySummary(criteria: AnalysedCriterion[]): SeveritySummary[] {
  const aggregatedResults = criteria.reduce(
    (acc, elt) => ((acc[elt.severity] = (acc[elt.severity] || 0) + 1), acc),
    {}
  );
  return Object.keys(aggregatedResults)
    .map((severity: Severity) => {
      return {
        type: severity,
        className: `severity-${severity.toLowerCase()}`,
        total: aggregatedResults[severity],
        label: i18n[`Global.Severity.${severity.toLowerCase()}`],
      };
    })
    .sort((s1, s2) => getOrder(s1.type) - getOrder(s2.type));
}
